import { useState } from "react";
import { Plus, Check } from "lucide-react";
import { api } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function DictSelect({ kind, items, value, onChange, onCreated, placeholder, testid }) {
  const [adding, setAdding] = useState(false);
  const [name, setName] = useState("");

  const create = async () => {
    if (!name.trim()) return;
    const { data } = await api.post(`/dict/${kind}`, { name: name.trim() });
    setName("");
    setAdding(false);
    onCreated?.();
    onChange(data.id);
  };

  if (adding)
    return (
      <div className="flex gap-2">
        <Input
          autoFocus
          value={name}
          placeholder="Новое значение"
          data-testid={`${testid}-new-input`}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && create()}
        />
        <Button type="button" size="icon" data-testid={`${testid}-new-save`} onClick={create}>
          <Check className="h-4 w-4" />
        </Button>
      </div>
    );

  return (
    <div className="flex gap-2">
      <Select value={value || ""} onValueChange={onChange}>
        <SelectTrigger data-testid={testid} className="flex-1">
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {items.map((i) => (
            <SelectItem key={i.id} value={i.id} data-testid={`${testid}-option-${i.id}`}>
              {i.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button type="button" variant="outline" size="icon" data-testid={`${testid}-add`} onClick={() => setAdding(true)}>
        <Plus className="h-4 w-4" />
      </Button>
    </div>
  );
}
